import { yup } from '@/libs/yup';
import { hasPermission } from '@/utils/permission';
import { StressCheckRoleOptions, HealthCheckRoleOptions, UserManageRoleOptions } from './roleOptions';

export const schema = yup.object({
  stressCheckRole: yup
    .string()
    .notRequired()
    .oneOf(StressCheckRoleOptions.map(opt => opt.value))
    .when('$currentUser', {
      is: currentUser => hasPermission(currentUser, 'user_manage_edit_stress_check_roles'),
      then: schema => schema.required()
    })
    .label('ストレスチェック権限'),
  healthCheckRole: yup
    .string()
    .notRequired()
    .oneOf(HealthCheckRoleOptions.map(opt => opt.value))
    .when('$currentUser', {
      is: currentUser => hasPermission(currentUser, 'user_manage_edit_regular_health_checkup_roles'),
      then: schema => schema.required()
    })
    .label('定期健康診断権限'),
  userManageRole: yup
    .string()
    .notRequired()
    .oneOf(UserManageRoleOptions.map(opt => opt.value))
    .when('$currentUser', {
      is: currentUser => hasPermission(currentUser, 'user_manage_edit_user_manage_roles'),
      then: schema => schema.required()
    })
    .label('管理者追加・削除')
});

export type Schema = yup.InferType<typeof schema>;
